<template>
    <a-modal v-model="visible" :title="'添加'+title+'类目'" on-ok="handleOk">
        <template slot="footer">
            <a-button key="submit" type="primary" :loading="loading" @click=" handleOk">
            确定
            </a-button>
            <a-button key="back"   @click="handleCancel">
            取消
            </a-button>
        </template>

        <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" >
            <a-form-item :label="title+'类目名'">
                <a-input
                ref="nameInput"
                    v-decorator="['categoryName', { rules: [{ required: true, message: '请输入类目名称!' }] }]"
                />
            </a-form-item>
        </a-form>

    </a-modal>
</template>
<script>
export default {
  data() {
    return {
      parentCategoryId:'',
      loading: false,
      visible: false,
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    };
  },
  props:{
    title:{
      type:String,
      default:'添加二级类目'
    }
  },
  methods: {
    showModal(id) {
      this.parentCategoryId = id||'';
      this.visible = true;
       this.$nextTick(()=>{ //自动获取焦点 element组件autofocus失效
            this.$refs.nameInput.focus()
        })
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = {...values}
          this.loading = true;
          if (this.parentCategoryId) {
            params.parentCategoryId = this.parentCategoryId;
          }
          let url = this.title == '二级'?'/secondaryCategory/appendRecord':'primaryCategory/appendRecord'
          this.$http.post(url,params).then(res=>{
            if (res.result) {
              this.form.resetFields();
              this.$message.success('新增成功');
              this.handleCancel();
            } else {
              this.$message.warning(res.message)
            }
          })
          this.loading = false;
        }
      });
    },
    handleCancel(e) {
      this.visible = false;
      this.form.resetFields();
      this.$emit('getdata')
    },
  },
};
</script>
